module.exports = __webpack_public_path__ + "static/media/barkbliss-4.3a768193.jpg";